module.exports = __webpack_public_path__ + "static/media/galerija_2017 (28).e7d4e4f8.jpg";